'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';

import {
  ForgotPasswordFormData,
  ForgotPasswordSchema
} from '#/lib/validation/auth';
import TextInput from '#/components/form/text-input';
import { zodResolver } from '@hookform/resolvers/zod';

import { toast } from 'react-toastify';
import { ROUTES } from '#/data/constants';
import { useRouter } from 'next/navigation';
import IconButton from '#/components/button/icon-button';
import { Icons } from '#/components/icons';

import { requestPasswordReset } from '#/actions/server';

export const ForgotPasswordForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<ForgotPasswordFormData>({
    resolver: zodResolver(ForgotPasswordSchema),
    defaultValues: {
      email: ''
    }
  });
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: ForgotPasswordFormData) => {
    try {
      setIsLoading(true);
      // 계정 조회와 메일 발송은 서버가 한 번에 한다(baikal-nlp #1831). 가입 여부를 드러내지 않도록
      // 결과와 관계없이 같은 안내를 보인다.
      await requestPasswordReset(data.email);
      router.push(ROUTES.ROOT);
      toast.success(
        '가입된 이메일이면 비밀번호 초기화 메일을 보냈습니다. 메일함을 확인해 주세요.'
      );
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="grid gap-6">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid gap-2">
          <div className="grid gap-1">
            <TextInput
              name="email"
              placeholder="이메일"
              register={register}
              errors={errors}
            />
          </div>
          <IconButton
            disabled={isLoading}
            Icon={Icons.send}
            text="비밀번호 변경 메일 전송"
          />
        </div>
      </form>
    </div>
  );
};
